<template>
  <v-container>
    <h1>
      <v-icon class="iconHeader">mdi-account-multiple-outline</v-icon>
      {{ $t("views.users.header") }}
    </h1>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>